document.addEventListener('DOMContentLoaded', function () {
  // Add event listener for all wear-with__add buttons
  const buttons = document.querySelectorAll('.wear-with__add-btn');
  if (!buttons.length) return;

  const getVariantId = (productId) => {
    const variant = document.querySelector(`div[data-product-id="${productId}"] .dropdown__items li._current`);
    return variant
      ? variant.getAttribute('data-value')
      : document.querySelector(`#variant-${productId}`).value;
  };

  const getQuantity = (productId) => {
    const quantityInput = document.querySelector(`#Quantity-${productId}`);
    return quantityInput ? quantityInput.value : 1;
  };

  const getSectionsToRender = () => [
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    },
    {
      id: 'CartDrawer',
      selector: '#CartDrawer',
      section: 'cart-drawer',
    },
  ];

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      let self = this;
      const productId = this.dataset.productId;
      const variantId = getVariantId(productId);
      const quantity = getQuantity(productId);
      const errorMessage = $(`.pdp-form__error-${productId}`);

      if (!variantId ) {
        errorMessage.removeAttr('hidden').text('Select size');

        setTimeout(function() {
          errorMessage.text('').attr('hidden', true);
        }, 5000);
      }

      if (!variantId || !quantity) {
        console.error('Missing variant ID or quantity');
        return;
      }

      this.classList.add('loading');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: variantId,
          quantity: quantity,
          sections: getSectionsToRender().map((section) => section.section),
          currency: window.Shopify?.currency?.active,
        },
        success: function(response){
          $('cart-drawer').removeClass('is-empty');
          $('cart-drawer').load(location.href + " #CartDrawer");

          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.cart.renderContents(response);

          self.classList.remove('loading');

        },
        error: function (xhr) {
          if (xhr.responseJSON.message) {
            errorMessage.removeAttr('hidden').text(xhr.responseJSON.message);
          }

          setTimeout(function() {
            errorMessage.text('').attr('hidden', true);
          }, 5000);

          self.classList.remove('loading');
        }
      });
    });
  });
});
